import { defineNuxtPlugin } from '#app'
import { createApp, h, ref } from 'vue'
import Toast from '~/components/ui/Toast.vue'

export default defineNuxtPlugin((nuxtApp) => {
  // 创建一个全局状态
  const visible = ref(false)
  const message = ref('')
  const type = ref('error')
  const duration = ref(3000)

  // 创建一个挂载点
  let mountPoint: HTMLElement | null = null

  // 确保只在客户端执行
  if (process.client) {
    // 创建一个挂载点
    mountPoint = document.createElement('div')
    document.body.appendChild(mountPoint)

    // 创建一个 Toast 实例
    const app = createApp({
      setup() {
        return () => h(Toast, {
          message: message.value,
          type: type.value,
          duration: duration.value,
          visible: visible.value,
          'onUpdate:visible': (value: boolean) => {
            visible.value = value
          }
        })
      }
    })

    // 挂载 Toast 实例
    app.mount(mountPoint)
  }

  // 定义 Toast API
  const toast = {
    show(msg: string, toastType: string = 'error', toastDuration: number = 3000) {
      message.value = msg
      type.value = toastType
      duration.value = toastDuration
      visible.value = true

      // 自动关闭
      setTimeout(() => {
        visible.value = false
      }, toastDuration)
    },
    success(msg: string, toastDuration: number = 3000) {
      this.show(msg, 'success', toastDuration)
    },
    error(msg: string, toastDuration: number = 3000) {
      this.show(msg, 'error', toastDuration)
    },
    warning(msg: string, toastDuration: number = 3000) {
      this.show(msg, 'warning', toastDuration)
    }
  }

  // 将 Toast API 添加到全局
  nuxtApp.provide('toast', toast)
})
